// Re-export only. The gate moved to `@jusbrasil-web/shared-auth-flows` so both
// `scope:auth` and `scope:landing-pages` read the same allow-list — it is a
// security boundary on public POST endpoints and must stay single-sourced.
export { isAllowedApiOrigin } from '@jusbrasil-web/shared-auth-flows'
